var map = {
	"./pages/maps/maps.module": [
		"./src/app/pages/maps/maps.module.ts"
	],
	"./pages/pages/pages.module": [
		"./src/app/pages/pages/pages.module.ts",
		"pages-pages-pages-module"
	],
	"./pages/ui/ui.module": [
		"./src/app/pages/ui/ui.module.ts",
		"pages-ui-ui-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;